
import RouterConfig from './navigation';

const App = () => {
  return <RouterConfig />;

};


export default App;
